import * as Logger from '@mamdev/navigator.frontend-logger'
import { initMonitoringService, monitoringService } from './service/monitoring/monitoring.service'
import {
  UppClient as UppClientInterface,
  UppClientOptions
} from './interfaces'
import { ContentService } from './service/content/content-service'
import { validateSettings } from '../util/validate-settings'
import { CONFIG_VERSION } from '../config'
import { getForcedContentData } from '../util/get-forced-content-data'

/**
 * Universal Playout Platform client library
 */
export class UppClient implements UppClientInterface {
  private moduleName = 'UppClient'
  private contentService: ContentService

  public version: string = CONFIG_VERSION
  public options: UppClientOptions = null

  /**
   * Initialize UPP. Any available content items will be displayed. When no more content is available, the Promise
   * returned by this function will resolve.
   * The Promise will reject if there are any runtime errors.
   * @param options
   */
  public async init(options: UppClientOptions): Promise<void> {
    validateSettings(options);
    Logger.setLogLevel(typeof options.logLevel === 'number' ? options.logLevel : Logger.LogLevel.warn)

    if (!options.contentParameters) {
      options.contentParameters = {}
    }

    if (!options.touchpointReference) {
      options.touchpointReference = location.origin
    }

    this.options = Object.assign({}, options)

    initMonitoringService(options)
    const { name, variant } = getForcedContentData(options.forceContent)
    monitoringService?.monitorUppLifecycleStarted(name, variant)

    Logger.debug(this.moduleName, 'init', 'Module initialized.')

    this.contentService = new ContentService()
    try {
      await this.contentService.init(this.options)
    } catch (e) {
      Logger.error(`[${this.moduleName}] init`, e)
      throw e
    } finally {
      this.destroy()
    }
  }

  private destroy(): void {
    monitoringService?.flush()
    if (typeof this.contentService?.destroy === 'function') {
      this.contentService.destroy()
    }
    this.options = null
    this.contentService = null;
  }

}

